import { supabase } from './supabase'
import { deleteMenuImage } from './menuImages'

/**
 * İşletme logosu (2 Kas 2026), "menu" kovasında <kurum>/logo-<rastgele>.png.
 *
 * Ürün fotoğrafından farkı PNG kalması: logolar çoğunlukla şeffaf, JPEG'e
 * çevrilince koyu temada beyaz bir kutu oluyordu. En uzun kenar 512 px,
 * sol üstte 28 px gösteriliyor; ekran yoğunluğu ve Hesabım'daki kutu için fazlası.
 * Her yükleme yeni ad alıyor, eski dosya silinir (önbellek sorunu yok).
 */
const BUCKET = 'menu'
const MAX_SIDE = 512

function client() {
  if (!supabase) throw new Error('Bağlantı yok.')
  return supabase
}

async function shrinkPng(file: File): Promise<Blob> {
  const url = URL.createObjectURL(file)
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image()
      el.onload = () => resolve(el)
      el.onerror = () => reject(new Error('Bu görsel açılamadı. PNG ya da JPG seçin.'))
      el.src = url
    })
    const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight))
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(img.naturalWidth * scale))
    canvas.height = Math.max(1, Math.round(img.naturalHeight * scale))
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('Görsel işlenemedi.')
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
    return await new Promise<Blob>((resolve, reject) =>
      canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Görsel işlenemedi.'))), 'image/png'),
    )
  } finally {
    URL.revokeObjectURL(url)
  }
}

/** Logoyu küçültüp yükler, kuruma yazar, eskisini siler. */
export async function uploadTenantLogo(tenantId: string, file: File, previous: string | null): Promise<string> {
  const blob = await shrinkPng(file)
  if (blob.size > 2 * 1024 * 1024) throw new Error('Görsel çok büyük, daha sade bir logo seçin.')
  const path = `${tenantId}/logo-${crypto.randomUUID().slice(0, 8)}.png`
  const up = await client().storage.from(BUCKET).upload(path, blob, {
    contentType: 'image/png',
    cacheControl: '31536000',
  })
  if (up.error) throw new Error(up.error.message)
  const url = client().storage.from(BUCKET).getPublicUrl(path).data.publicUrl
  const { error } = await client().from('tenants').update({ logo_url: url }).eq('id', tenantId)
  if (error) {
    await deleteMenuImage(url)
    throw new Error(error.message)
  }
  await deleteMenuImage(previous)
  return url
}

/** Logoyu kaldırır; yerine Adissoo işareti döner. */
export async function removeTenantLogo(tenantId: string, previous: string | null): Promise<void> {
  const { error } = await client().from('tenants').update({ logo_url: null }).eq('id', tenantId)
  if (error) throw new Error(error.message)
  await deleteMenuImage(previous)
}
